import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface ReCaptchaProps {
  onChange: (value: string | null) => void;
}

const ReCaptchaComponent: React.FC<ReCaptchaProps> = ({ onChange }) => {
  return (
    <ReCAPTCHA
      sitekey="6LfZCo4rAAAAAIsqk_4eQ1aqoRFdCogE1U_2uJcW"
      onChange={onChange}
    />
  );
};

export default ReCaptchaComponent;
